
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { MeetingNotes } from "../../types/meetings";

interface ActionItemNotesProps {
  notesText: string;
  setNotesText: (text: string) => void;
  handleSaveNotes: () => void;
  meetingNotes: MeetingNotes | null;
}

export function ActionItemNotes({ notesText, setNotesText, handleSaveNotes, meetingNotes }: ActionItemNotesProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Additional Notes</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <Textarea
            value={notesText}
            onChange={(e) => setNotesText(e.target.value)}
            placeholder="Add any additional notes or context here..."
            className="min-h-[100px]"
          />
          <Button onClick={handleSaveNotes}>Save Notes</Button>
        </div>
      </CardContent>
    </Card>
  );
}